export const STATUS_CALCULATION_DONE = "CALCULATION_DONE";

export const OFFICER_ONBOARDING_LENGTH = 7;
export const LEADER_ONBOARDING_LENGTH = 7;

export const AVG_FOOTPRINTS = {
  de: 9,
  world: 5,
};

export const getDate = (date) => {
  if (date.getFullYear() === 1970) return "Done";
  return `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`;
};

export function toFixedNumber(num, digits, base) {
  var pow = Math.pow(base || 10, digits);
  return Math.round(num * pow) / pow;
}

export function isMobile() {
  if (typeof window !== "undefined") {
    const isMobile = window.matchMedia("only screen and (max-width: 767px)");
    return isMobile.matches;
  } else return false;
}

export function arrToObj(array, key) {
  const initialValue = {};
  return array.reduce((obj, item) => {
    return {
      ...obj,
      [item[key]]: item,
    };
  }, initialValue);
}

export function clearFromUndefined(obj) {
  Object.keys(obj).forEach((key) => obj[key] === undefined && delete obj[key]);
}

export function timestampToLocalTime(timestamp) {
  const newTime = new Date();
  newTime.setTime(timestamp + 3600000);
  const dateString = newTime.toUTCString();
  return dateString.substr(0, dateString.length - 3);
}

export function convertToNumber(something) {
  if (!isNaN(something)) {
    // val = +val
    return parseFloat(something);
  } else {
    const val = something.replace(",", ".");
    return parseFloat(val);
  }
}

export const openInNewTab = (url) => {
  var win = window.open(url, "_blank");
  win.focus();
};

export function normalizeFootprint(value) {
  if (value || value === 0) {
    let val = value;
    // if there is a . turn it into a ,
    if (value.toString().match(/\d+.($|\d+)/)) {
      val = value.toString().replace(".", ",");
    }
    // if there is something different than a number or , or . remove it
    val = val.replace(/[^0-9,]/g, "");
    return val;
  }
}

export function copyToClipboard(str) {
  const el = document.createElement("textarea");
  el.value = str;
  el.setAttribute("readonly", "");
  el.style.position = "absolute";
  el.style.left = "-9999px";
  document.body.appendChild(el);
  el.select();
  document.execCommand("copy");
  document.body.removeChild(el);
}

export const downloadCsv = (fileName, data) => {
  // Parse csv
  const { Parser } = require("json2csv");
  const json2csvParser = new Parser();
  const csv = json2csvParser.parse(data);

  const exportedFilename = `${fileName || "export"}.csv`;
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });

  if (navigator.msSaveBlob) {
    // IE 10+
    navigator.msSaveBlob(blob, exportedFilename);
  } else {
    var link = document.createElement("a");
    if (link.download !== undefined) {
      // feature detection
      // Browsers that support HTML5 download attribute
      var url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", exportedFilename);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
};
